const formatSpecialty = (specialty: string) =>
  specialty === 'General Practice' ? 'GP' : specialty;

export const formatSpecialties = (specialties: string[]) =>
  specialties.map(formatSpecialty).join(', ');
